
import { Global_Searching } from "../../api/global/Global";
import {
  FETCH_Global_Search_DATA_REQUEST,
  FETCH_Global_Search_DATA_SUCCESS,
  FETCH_Global_Search_DATA_FAILURE
} from "../types"

export const fetchGlobalSearchingData = () => async (dispatch, getState) => {
 const { globalSearchData } = getState();
  const { status } = globalSearchData;

  if (status === "pending") {
    return;
  }

   if (status === "success") {
    return;
  }


  dispatch({ type: FETCH_Global_Search_DATA_REQUEST });
  try {
    const response = await Global_Searching();    
    console.log("global_search_response", response);
    if (response?.data?.status == 200) {
      dispatch({
        type: FETCH_Global_Search_DATA_SUCCESS,
        payload: response?.data?.data,
      });
    } else {
      dispatch({
        type: FETCH_Global_Search_DATA_FAILURE,
        payload: "Failed to fetch global searching data",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_Global_Search_DATA_FAILURE,
      payload: error.message,
    });
  }
};